import MapProfileAttribute from './mapProfileAttribute.model';
import ConcatProfileAttribute from './concatProfileAttribute.model';
import { Utils } from '@/core/Utils';

export default class ProfileAttribute {

    public id?: number = 0;
    public dataTypeId?: number | null = null;
    public widthId?: number | null  = null;
    public imageFormatId?: number | null  = null;
    public orden?: number | null  = null;
    public guid: string = Utils.newGUID();

    public configRequiredSectionFieldId?: number | null  = null;
    public name: string = "";
    public mapName: string = "";
    public isRequired : boolean = false;
    public showTitle : boolean = true;
    public visible : boolean = true;
    public isRounded : boolean = false;
    public isPrimaryKey : boolean = false;
    public dataType : any = null;
    public imageFormat : any = null;
    public width : any = null;
    public widthNumber: string = "";
    public dateReceiveFormat: string = "";
    public dateShowFormat: string = "";
    public mapProfileAttribute: Array<MapProfileAttribute> = [];
    public concatProfileAttribute: Array<ConcatProfileAttribute> = [];
    public deleted: boolean = false;
    
    public psOnline : boolean = true;
    public psOnlineMovil : boolean = true;
    public psWeb : boolean = true;
    public psWebMovil : boolean = true;
    
    init(){
        this.id = 0;
        this.dataTypeId = null;
        this.widthId = null;
        this.imageFormatId = null;
        this.configRequiredSectionFieldId = null;
        this.orden = null;
        this.widthNumber = "";
        this.name = "";
        this.mapName = "";
        this.dateReceiveFormat = "";
        this.dateShowFormat = "";
        this.isRequired = false;
        this.showTitle = true;
        this.visible = true;
        this.isRounded = false;
        this.isPrimaryKey = false;
        this.dataType = null;
        this.imageFormat = null;
        this.guid = Utils.newGUID();
        this.width = null;
        this.mapProfileAttribute = [];
        this.concatProfileAttribute = [];
        this.deleted = false;

        this.psOnline = true;
        this.psOnlineMovil = true;
        this.psWeb = true;
        this.psWebMovil = true;

    }
}